import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import type { Host } from '#dn-types/host.ts';
import { computeHostStatus } from '#util/hostStatus.ts';
import { DATE_AT_TIME_FORMAT } from '#util/time.ts';

type Props = {
  host: Pick<Host, 'createdAt' | 'isBlocked' | 'id'> & {
    metadata: Pick<Host['metadata'], 'lastSeenAt' | 'platform'>;
  };
  dataUpdatedAt: Date;
};

export function LastSeen({ host, dataUpdatedAt }: Props) {
  const status = computeHostStatus(host, dataUpdatedAt);
  const { lastSeenAt } = host.metadata;

  if (status === 'unknown') {
    return 'Last seen not available';
  }

  // host.metadata.lastSeenAt check mostly just for TypeScript's benefit here
  if (status === 'unenrolled' || !lastSeenAt) {
    return 'Not enrolled';
  }

  if (status === 'online') {
    return 'Online';
  }

  return (
    <>
      Last seen <Timestamp datetime={lastSeenAt} format={DATE_AT_TIME_FORMAT} />
    </>
  );
}
